<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first codigo -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="codigo"
              rules="required"
            >
              <b-form-group label="Codigo" label-for="v-codigo">
                <b-form-input
                  id="v-codigo"
                  v-model="socialSecurity.codigo"
                  :state="errors.length > 0 ? false : null"
                  placeholder="codigo"
                  data-cy="codigo"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!socialSecurity.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') &&
                      !socialSecurity.id)
                  "
                />
                <small data-cy="v-codigo-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="socialSecurity.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!socialSecurity.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') &&
                      !socialSecurity.id)
                  "
                />
                <small data-cy="v-description-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Grupo de Previdência Social"
              rules="required"
            >
              <b-form-group
                label="Grupo de Previdência Social"
                label-for="v-socialSecurityGroup"
              >
                <v-select
                  v-model="socialSecurity.grupoPrevidenciaSocialId"
                  data-cy="grupo"
                  :reduce="
                    (comboSocialSecurityGroup) => comboSocialSecurityGroup.id
                  "
                  label="nome"
                  :disabled="
                    (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                      !!socialSecurity.id) ||
                    (!verificarPermissao('ROLE_ADMIM_INSERIR') &&
                      !socialSecurity.id)
                  "
                  :options="comboSocialSecurityGroup"
                  :state="errors.length > 0 ? false : null"
                />
                <small data-cy="v-grupo-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col v-if="socialSecurity.id" cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="socialSecurity.ativo"
                :checked="socialSecurity.ativo"
                name="check-button"
                switch
                inline
                :disabled="
                  (!verificarPermissao('ROLE_ADMIM_ATUALIZAR') &&
                    !!socialSecurity.id) ||
                  (!verificarPermissao('ROLE_ADMIM_INSERIR') &&
                    !socialSecurity.id)
                "
              >
                {{ socialSecurity.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('socialSecuritySettingsModule', {
      socialSecurity: (state) => state.socialSecurity,
      comboSocialSecurityGroup: (state) => state.comboSocialSecurityGroup
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue
  },
  directives: {
    Ripple
  },
  mounted() {
    this.$store.dispatch(
      'socialSecuritySettingsModule/loadComboSocialSecurityGroup'
    )
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Previdência Social',
      required
    }
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.$store.dispatch('socialSecuritySettingsModule/resetSocialSecurity')
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.socialSecurity.id) {
            this.$store
              .dispatch(
                'socialSecuritySettingsModule/editSocialSecurity',
                this.socialSecurity
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'socialSecuritySettingsModule/insertNewSocialSecurity',
                this.socialSecurity
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.$refs.form.reset()
                this.$store.dispatch(
                  'socialSecuritySettingsModule/resetSocialSecurity'
                )
              })
          }
        }
      })
    }
  }
}
</script>
